import React from "react";
import { Redirect } from "react-router-dom";

/**
 * Legacy route — Sonic Prospect billing lives on /settings/plan.
 */
const ProspectPlansPage = () => <Redirect to="/settings/plan" />;

export default ProspectPlansPage;
